/*LIBRARY*/
import { useState, useEffect } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import COLOR_INPUT from "../common_input/COLOR_INPUT";

/*REDUX*/
import { edit_label_config } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const font_weight_array = [
  { key: "lighter", name: "Light" },
  { key: "normal", name: "Normal" },
  { key: "bold", name: "Bold" },
];
const label_config_state = {
  is_use_label_text: false,
  is_use_label_image: false,
  label_text_field_key_array: [],
  label_image_field_key_array: [],
  style_mode: "style_1",
  background_color_primary: "rgba(0,0,0,0)",
  outline_color_primary: "rgba(0,0,0,0)",
  text_color_primary: "rgba(0,0,0,1)",
  is_use_pin: false,
  text_stroke_width: 9,
  text_stroke_color: "rgba(255,255,255,1)",
  font_size: 13,
  font_weight: "bold",
  pin_height: 27,
};

const EDIT_LABEL = ({ auth, layer, loading_reducer, edit_label_config }) => {
  const [label_config, set_label_config] = useState(label_config_state);
  const [fields_text, set_fields_text] = useState([]);
  const [fields_image, set_fields_image] = useState([]);

  useEffect(() => {
    const { geo_layer_list, layer_id } = layer;
    const geo_layer =
      geo_layer_list.find((item) => item?.geo_layer?._id === layer_id)
        ?.geo_layer || {};

    const label_config = geo_layer?.label_config || label_config_state;
    if (label_config.is_use_label_text || label_config.is_use_label_image) {
      set_label_config({ ...label_config });
    }

    const fields = geo_layer?.fields || [];
    const fields_text = fields.filter((item) => item.type !== "image");
    const fields_image = fields.filter((item) => item.type === "image");
    set_fields_text([...fields_text]);
    set_fields_image([...fields_image]);
  }, [layer]);

  const on_toggle = (item) => {
    set_label_config((prev_label_config) => ({
      ...prev_label_config,
      [item]: !prev_label_config[item],
    }));
  };

  const on_change = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    set_label_config((prev_label_config) => ({
      ...prev_label_config,
      [name]: value,
    }));
  };

  const on_change_color = (object) => {
    const { name, value } = object;
    set_label_config((prev_label_config) => ({
      ...prev_label_config,
      [name]: value,
    }));
  };

  const on_set_is_use_pin = (is_use_pin) => {
    set_label_config((prev_label_config) => ({
      ...prev_label_config,
      is_use_pin: is_use_pin,
    }));
  };

  const on_set_font_weight = (font_weight) => {
    set_label_config((prev_label_config) => ({
      ...prev_label_config,
      font_weight: font_weight,
    }));
  };

  const on_toggle_array_item = (item, value) => {
    set_label_config((prev_label_config) => {
      let array = prev_label_config[item] || [];
      if (array.includes(value)) {
        array = array.filter((element) => element !== value);
      } else {
        array.push(value);
      }
      return {
        ...prev_label_config,
        [item]: array,
      };
    });
  };

  const on_save = () => {
    const { layer_id } = layer;
    const is_use_label_text = label_config?.is_use_label_text || false;
    const is_use_label_image = label_config?.is_use_label_image || false;
    const label_text_field_key_array =
      label_config?.label_text_field_key_array || [];
    const label_image_field_key_array =
      label_config?.label_image_field_key_array || [];
    const style_mode = label_config?.style_mode || "style_1";
    const background_color_primary =
      label_config?.background_color_primary || "#292571";
    const outline_color_primary =
      label_config?.outline_color_primary || "#ffffff";
    const text_color_primary = label_config?.text_color_primary || "#ffffff";
    const is_use_pin = label_config?.is_use_pin || false;
    const text_stroke_width = parseFloat(label_config?.text_stroke_width || 0);
    const text_stroke_color = label_config?.text_stroke_color || "#ffffff";
    const font_size = parseInt(label_config?.font_size || 16);
    const font_weight = label_config?.font_weight || "normal";
    const pin_height = parseInt(label_config?.pin_height || 25);
    const updated_label_config = {
      ...label_config,
      is_use_label_text,
      is_use_label_image,
      label_text_field_key_array,
      label_image_field_key_array,
      style_mode,
      background_color_primary,
      outline_color_primary,
      text_color_primary,
      is_use_pin,
      text_stroke_width,
      text_stroke_color,
      font_size,
      font_weight,
      pin_height,
    };
    const body = {
      geo_layer_id: layer_id,
      label_config: updated_label_config,
    };
    edit_label_config(body);
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //local state
  // label_config, fields_text, fields_image are now state variables

  //global props
  const { loading_item_array } = loading_reducer;

  //content

  return (
    <main
      style={{ maxHeight: "calc( 100vh - 200px )", overflowY: "auto" }}
      className="container_light"
    >
      <section className="container_light background_grey_light margin_bottom">
        <h1 className="text_bold margin_bottom">
          {dict?.["Select Column"]?.[language]}
        </h1>
        <div className="container_light background_white margin_bottom">
          <div className="two_container_list margin_bottom">
            <div
              className={
                label_config.is_use_label_text
                  ? "checklist_active"
                  : "checklist_not"
              }
              onClick={() => on_toggle("is_use_label_text")}
              data-mapid="onText"
            />
            <p className="text_bold margin_bottom">
              {dict?.["Use text labels"]?.[language]}
            </p>
          </div>

          {label_config.is_use_label_text && (
            <section className="margin_bottom">
              <p className="text_medium">
                {dict?.["Select the column used as the label"]?.[language]}
              </p>
              <div
                style={{
                  maxHeight: "calc( 50vh - 200px )",
                  overflowY: "auto",
                }}
              >
                <table>
                  <tbody>
                    {fields_text.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td style={{ width: "20px" }}>
                            <div
                              className={
                                label_config.label_text_field_key_array.includes(
                                  item?.key
                                )
                                  ? "checklist_active"
                                  : "checklist_not"
                              }
                              onClick={() =>
                                on_toggle_array_item(
                                  "label_text_field_key_array",
                                  item?.key
                                )
                              }
                              data-mapid={`selectLabel-${idx}`}
                            />
                          </td>
                          <td>{item?.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
          )}
        </div>

        <div className="container_light background_white margin_bottom">
          <div className="two_container_list margin_bottom">
            <div
              className={
                label_config.is_use_label_image
                  ? "checklist_active"
                  : "checklist_not"
              }
              onClick={() => on_toggle("is_use_label_image")}
              data-mapid="onLabels"
            />
            <p className="text_bold margin_bottom">
              {dict?.["Use image labels"]?.[language]}
            </p>
          </div>

          {label_config.is_use_label_image && (
            <section className="margin_bottom">
              <p className="text_medium">
                {dict?.["Select the image column"]?.[language]}
              </p>
              <div
                style={{
                  maxHeight: "calc( 50vh - 200px )",
                  overflowY: "auto",
                }}
              >
                <table>
                  <tbody>
                    {fields_image.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td style={{ width: "20px" }}>
                            <div
                              className={
                                label_config.label_image_field_key_array.includes(
                                  item?.key
                                )
                                  ? "checklist_active"
                                  : "checklist_not"
                              }
                              onClick={() =>
                                on_toggle_array_item(
                                  "label_image_field_key_array",
                                  item?.key
                                )
                              }
                              data-mapid={`selectImage-${idx}`}
                            />
                          </td>
                          <td>{item?.name}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </section>
          )}
        </div>
      </section>

      <section className="container_light background_grey_light margin_bottom">
        <h1 className="text_bold margin_bottom">
          {dict?.["Text and Outline"]?.[language]}
        </h1>
        <div className="container_light background_white margin_bottom">
          <p className="text_medium">{dict?.["Text size"]?.[language]}</p>
          <input
            name="font_size"
            value={label_config.font_size}
            onChange={on_change}
            type="number"
            data-mapid="textSize"
          />
          <br />
          <br />
          <p className="text_medium margin_bottom">
            {dict?.["Text thickness"]?.[language]}
          </p>
          {font_weight_array.map((item, idx) => {
            return (
              <button
                key={idx}
                className={`button_small outline_black margin_right margin_bottom ${
                  label_config.font_weight === item.key
                    ? "background_black"
                    : "button_white"
                }`}
                onClick={() => on_set_font_weight(item.key)}
                data-mapid={`textThickness-${idx}`}
              >
                {item.name}
              </button>
            );
          })}
        </div>
        <div className="container_light background_white margin_bottom">
          <p className="text_medium">{dict?.["Text color"]?.[language]}</p>
          <COLOR_INPUT
            on_change={on_change_color}
            name="text_color_primary"
            value={label_config.text_color_primary}
          />
        </div>
        <div className="container_light background_white">
          <p className="text_medium">
            {dict?.["Text outline color"]?.[language]}
          </p>
          <COLOR_INPUT
            on_change={on_change_color}
            name="text_stroke_color"
            value={label_config.text_stroke_color}
          />
          <br />
          <p className="text_medium">
            {dict?.["Text outline thickness"]?.[language]}
          </p>
          <input
            name="text_stroke_width"
            value={label_config.text_stroke_width}
            onChange={on_change}
            type="number"
          />
        </div>
      </section>

      <section className="container_light background_grey_light margin_bottom">
        <h1 className="text_bold margin_bottom">
          {dict?.["Text Box"]?.[language]}
        </h1>
        <div className="container_light background_white margin_bottom">
          <p className="text_medium">
            {dict?.["Text background color"]?.[language]}
          </p>
          <COLOR_INPUT
            on_change={on_change_color}
            name="background_color_primary"
            value={label_config.background_color_primary}
          />
        </div>
        <div className="container_light background_white">
          <p className="text_medium">
            {dict?.["Background outline color"]?.[language]}
          </p>
          <COLOR_INPUT
            on_change={on_change_color}
            name="outline_color_primary"
            value={label_config.outline_color_primary}
          />
        </div>
      </section>

      <section className="container_light background_grey_light margin_bottom">
        <h1 className="text_bold margin_bottom">
          {dict?.["Pin Options"]?.[language]}
        </h1>
        <div className="container_light background_white">
          <p className="text_medium margin_bottom">
            {dict?.["Use pin"]?.[language]}
          </p>
          <button
            className={`button_small outline_black margin_right ${
              label_config.is_use_pin === false
                ? "background_black"
                : "button_white"
            }`}
            onClick={() => on_set_is_use_pin(false)}
            data-mapid="withoutPin"
          >
            {dict?.["Without pin"]?.[language]}
          </button>
          <button
            className={`button_small outline_black margin_right ${
              label_config.is_use_pin === true
                ? "background_black"
                : "button_white"
            }`}
            onClick={() => on_set_is_use_pin(true)}
            data-mapid="withPin"
          >
            {dict?.["Use pin"]?.[language]}
          </button>
          <br />
          <br />
          <p className="text_medium">{dict?.["Pin length"]?.[language]}</p>
          <input
            name="pin_height"
            value={label_config.pin_height}
            onChange={on_change}
            type="number"
            data-mapid="pinLength"
          />
        </div>
      </section>

      {loading_item_array.includes("edit_label_config") ? (
        <div className="button background_black">
          {dict?.["Saving"]?.[language]}...
        </div>
      ) : (
        <button
          className="button background_black"
          onClick={on_save}
          data-mapid="clickSave"
        >
          {dict?.["Save"]?.[language]}
        </button>
      )}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  loading_reducer: state.loading_reducer,
});

export default connect(mapStateToProps, { edit_label_config })(EDIT_LABEL);
